import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { fetchTreesAction, selectTree, setTreeSearchVisible } from './store/actions';
import TreeMap from './components/TreeMap';
import TreeInfo from './components/TreeInfo';
import TreeSearch from './components/TreeSearch';
import { createTreeSearch } from './services/treeSearch';

const AppWrap = styled.div`
  display: flex;
  position: fixed;
  width: 100vw;
  height: 100vh;
`;

const AppWrapInner = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const AppWrapMap = styled.div`
  order: 2;
  flex: 1;

  @media (max-width: 600px) {
    order: 1;
    flex: 0 0 40%;
  }

`;

const AppWrapSide = styled.div`
  order: 1;
  flex: 0 0 50%;
  max-width: 400px;
  overflow-y: auto;
  position: relative;

  @media (max-width: 600px) {
    order: 2;
    flex: 1;
    max-width: 100%;
  }
`;

let treeSearch = undefined;

const App = (props) => {

  const dispatch = useDispatch();
  const trees = useSelector(state => state.trees);
  const treesLoaded = useSelector(state => state.treesLoaded);
  const selectedTree = useSelector(state => state.selectedTree);
  const treesVisible = useSelector(state => state.treesVisible);
  const treeSearchVisible = useSelector(state => state.treeSearchVisible);

  // fetch trees on load
  useEffect(() => { 
    if (!treesLoaded) dispatch(fetchTreesAction());

    if (treesLoaded && !treeSearch) {
      treeSearch = createTreeSearch(trees);
    }

  });

  return (
    <AppWrap>
      <AppWrapInner>
        <AppWrapMap>
          <TreeMap
            trees={trees}
            selectedTree={selectedTree}
            treesVisible={treesVisible}
            onClickTree={treeKey => dispatch(selectTree(treeKey))}
          />
        </AppWrapMap>
        <AppWrapSide>
          <TreeInfo
            trees={trees}
            selectedTree={selectedTree}
            setSelectedTree={treeKey => dispatch(selectTree(treeKey))}
            openSearch={() => dispatch(setTreeSearchVisible(true))}
          />
        </AppWrapSide>
      </AppWrapInner>
      {treeSearchVisible ? (
        <TreeSearch
          treeSearch={treeSearch}
          setSelectedTree={treeKey => dispatch(selectTree(treeKey))}
          closeSearch={() => dispatch(setTreeSearchVisible(false))}
        />
      ) : null}
    </AppWrap>
  );
}

export default App;
